export default "__VITE_ASSET__7afca45a__"